import { Auth } from 'aws-amplify';
import { ServiceContext } from 'utilities/service.utils';
import { impersonateUserHeaderToken } from 'utilities/service.utils';

const AppService = new ServiceContext(
  process.env.REACT_APP_RSOTF_API_NAME,
  async (headers: any) => {
    const impersonateUserToken = await impersonateUserHeaderToken();
    let session: any = {};
    try {
      session = Auth && (await Auth.currentSession());
    } catch (error) {
      session = undefined;
    }
    if (session && session.getIdToken()) {
      const token = session.getIdToken().getJwtToken();
      if (impersonateUserToken) {
        headers['Authorization'] = token;
        headers['x-impersonate-user-token'] = impersonateUserToken;
      } else {
        headers['Authorization'] = token;
      }
    }
  }
);

export default AppService;
